var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9854",
    "data-name": "Group 9854",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5460"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#31e5e5",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5525",
    "data-name": "Rectangle 5525",
    width: 512,
    height: 512,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10020",
    "data-name": "Group 10020",
    transform: "translate(-214.588 -2242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5623",
    "data-name": "Rectangle 5623",
    width: 393.949,
    height: 394.586,
    transform: "translate(268.584 2307.291)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5624",
    "data-name": "Rectangle 5624",
    width: 355.338,
    height: 355.912,
    transform: "translate(287.887 2326.627)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5460-2",
    "data-name": "Rectangle 5460",
    width: 492,
    height: 492,
    rx: 246,
    transform: "translate(224.588 2252)",
    fill: "#3a5686",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 214.59, 2242)",
    filter: "url(#Rectangle_5460)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5460-3",
    "data-name": "Rectangle 5460",
    width: 492,
    height: 492,
    rx: 246,
    transform: "translate(10 10)",
    fill: "#fff",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10016",
    "data-name": "Group 10016",
    transform: "translate(295.806 2343.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_352",
    "data-name": "Subtraction 352",
    d: "M49.891,99.789A49.892,49.892,0,0,1,14.613,14.617,49.892,49.892,0,1,1,85.172,85.174,49.564,49.564,0,0,1,49.891,99.789ZM32.8,45.691v6.777l.457.484c6.43,6.889,11.48,12.814,17.539,20.141l.5.586h11.18l-2.215-2.713c-4.363-5.35-10.074-12.25-15.52-18.189A15.171,15.171,0,0,0,58.379,40.822h8.008V33.9H58.277a12.462,12.462,0,0,0-1.684-4.018h9.781l.027-6.924H32.844v8.008h6.766a10.14,10.14,0,0,1,8.52,2.934H32.844v6.924H48.789c-1.633,4.238-7.207,4.871-10.387,4.871H32.8Z",
    transform: "translate(124.651 194.378)",
    fill: "#4195c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_351",
    "data-name": "Subtraction 351",
    d: "M49.891,99.789A49.892,49.892,0,0,1,14.613,14.617,49.892,49.892,0,1,1,85.172,85.174,49.564,49.564,0,0,1,49.891,99.789Zm.891-77.561c-5.867,0-10.6.441-12.07,1.123-5.145,2.408-5.582,9.625-5.863,14.4l0,.07c-.129,2-.227,3.586-.676,4.023a2.958,2.958,0,0,1-1.16.148c-2.273.1-7.609.342-10.2,5.324-1.109,2.115-4.582,14.4-4.934,16.766-.348,2.4-.129,4,.691,5.033.879,1.1,2.465,1.652,5.473,1.9,7.441.625,18.836,1,30.465,1,11.4,0,21.871-.359,28.734-.984,3.637-.338,5.719-1.363,5.605-5.6-.051-2.293-4.043-16.043-5.105-18.115C79.145,42.338,73.793,42.1,71.508,42a2.974,2.974,0,0,1-1.16-.148c-.441-.443-.512-2-.6-3.982-.211-4.576-.52-11.484-5.441-14.234C62.449,22.6,55.863,22.229,50.781,22.229Zm25.551,39.8h-17.2l-3-11.207H72.973c1.8,3.066,2.648,7.215,3.352,11.2Zm-26.941,0H26.184c-.055-.057-.07-.254-.035-.621.242-2.27,2.367-9.824,3-10.234.578-.379,1.918-.557,4.211-.557,1.691,0,3.742.1,5.387.176l.469.021c1.734.078,3.375.152,4.773.152a13.831,13.831,0,0,0,2.7-.187l2.7,11.246ZM61.359,41.865h-20.2l1.527-10.414c.3.033.793.051,1.512.051,1.145,0,2.8-.045,4.266-.084l.5-.012c1.992-.055,3.922-.1,5.645-.1,3.352,0,5.082.193,5.3.586l1.453,9.973Z",
    transform: "translate(252.48 192.613)",
    fill: "#4195c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_353",
    "data-name": "Subtraction 353",
    d: "M49.891,99.789A49.892,49.892,0,0,1,14.613,14.617,49.892,49.892,0,1,1,85.172,85.174,49.564,49.564,0,0,1,49.891,99.789ZM41.484,28.926a7.517,7.517,0,0,0-4,1.615c-1.5,1.014-13.441,12.047-13.891,13.025-.75,1.676-.77,25.725-.395,28.762.441,3.783,1.785,4.535,5.586,4.871,5.324.5,14.594.807,24.2.807a213.886,213.886,0,0,0,21.5-.82c3.746-.441,4.539-1.848,4.879-5.59.59-6.4.281-13.553-.02-20.469l0-.059c-.191-4.529-.406-9.211-.34-13.531-.441-1.445-14.293-13.887-16.531-15.621-.172-.135-.34-.271-.512-.406l-.027-.018c-1.164-.93-2.273-1.809-3.734-1.809a3.887,3.887,0,0,0-.754.076c-2.152.418-4.734,3.049-7.234,5.594l-.008.014c-2.023,2.053-3.926,3.992-5.289,4.365a1.417,1.417,0,0,1-.367.049,2.861,2.861,0,0,1-1.16-.346l-.113-.053-.07-.031A3.981,3.981,0,0,0,41.484,28.926ZM62.168,68.383c-1.461,0-2.227-.141-2.551-.467a.559.559,0,0,1-.168-.412c.039-2,.09-4.105.16-6.623.211-7.57.4-14.109-.629-17.551-.41-1.363-2.352-2.846-4.234-4.281l-.023-.021a18.465,18.465,0,0,1-3.043-2.635c-.187-.83,1.563-2.164,3.254-3.453l.031-.021A27.726,27.726,0,0,0,57.324,31a1.161,1.161,0,0,1,.82-.338,1.21,1.21,0,0,1,.8.307l11.4,9.975V68.207c-.383-.008-.809-.014-1.293-.014-1.309,0-2.57.041-3.738.088l-.262.012C64.051,68.338,63.012,68.383,62.168,68.383Zm-12.016-.176H32.184V47.658c0-.283,1.895-2.148,4.227-4.158,2.07-1.791,4.5-3.705,5.133-3.705,1.9,0,4.934,3.057,7.367,5.512.449.449.863.863,1.242,1.236V68.207Z",
    transform: "translate(0 194.378)",
    fill: "#4195c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_354",
    "data-name": "Subtraction 354",
    d: "M36.891.3c31.3-3.543,55.348,24.5,46.57,54.9C74.133,87.523,31.488,95.816,9.879,70.176-11.547,44.816,3.887,4.043,36.891.3",
    transform: "translate(133.512 42.637)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10013",
    "data-name": "Group 10013",
    transform: "translate(148.007 65.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10015",
    "data-name": "Group 10015",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M67.626,491.284l-.047.047h0l-2.608,2.609-.486.486a5.991,5.991,0,0,1-4.266,1.768,5.92,5.92,0,0,1-4.635-2.21l-.039-.049A28.16,28.16,0,0,1,52.8,462.869c3.042-2.7,7.29,1.224,7.761,1.593l.023.018a.349.349,0,0,0-.177-.049.358.358,0,0,0-.179.047.355.355,0,0,0-.126.113c-.335.5-.654,1.017-.949,1.546a21.022,21.022,0,0,0,.482,21.235l.018.015s.023.049.031.062h0l.016.023v.014c.084.134.169.272.257.4l.14.208a.172.172,0,0,0,.021.027l.027.027.023.033C60.995,489.278,64.91,492.941,67.626,491.284Z",
    transform: "translate(-49.368 -456.495)",
    fill: "#244277",
    stroke: "#224074",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10014",
    "data-name": "Group 10014",
    transform: "translate(3.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M112.279,556.344l.047-.047c-2.723,1.658-6.631-2.005-7.442-3.094l-.023-.033a.361.361,0,0,0,.251.1.343.343,0,0,0,.247-.1l10.529-10.525,5.057,5.057Z",
    transform: "translate(-97.523 -521.507)",
    fill: "#244277",
    stroke: "#224074",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M211.436,462.172a.372.372,0,0,0-.268-.118.357.357,0,0,0-.169.043.382.382,0,0,0-.084.062l-11.817,11.8-5.048-5.048,9.382-9.379.014-.014h0c.819-.751,5.124-1.325,7.961,2.628Z",
    transform: "translate(-169.36 -454.118)",
    fill: "#244277",
    stroke: "#224074",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10013-2",
    "data-name": "Group 10013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M109.169,465.679l-.037.035-.029.037a6.8,6.8,0,0,1-5.567,3.068,3.875,3.875,0,0,1-2.509-.716l-26-26.009-.033-.018-.047-.058h-.01L74.915,442l-.023-.018c-.471-.37-4.719-4.293-7.761-1.593.313-.584.654-1.15,1.013-1.708a27.65,27.65,0,0,1,1.727-2.406l.045-.056A5.921,5.921,0,0,1,74.527,434a5.987,5.987,0,0,1,4.264,1.768l29.891,29.891a.357.357,0,0,0,.253.1A.388.388,0,0,0,109.169,465.679Z",
    transform: "translate(-67.13 -433.999)",
    fill: "#244277",
    stroke: "#224074",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M260.334,453.841a28.043,28.043,0,0,1-4.445,15.184,27.4,27.4,0,0,1-1.727,2.406l-.039.048a5.916,5.916,0,0,1-4.639,2.218,5.99,5.99,0,0,1-4.262-1.766l-3.832-3.83a3.874,3.874,0,0,0,2.509.716,6.781,6.781,0,0,0,5.567-3.063l.029-.037.037-.035h0a.468.468,0,0,0,.06-.072c.1-.146.195-.29.286-.438.072-.109.107-.167.109-.169.194-.321.389-.638.556-.94a21.007,21.007,0,0,0-.945-21.953l-.033-.049h0l-.018-.021c-2.838-3.952-7.143-3.379-7.961-2.628l3.634-3.634A5.992,5.992,0,0,1,249.484,434a5.916,5.916,0,0,1,4.631,2.2l.041.05A28.235,28.235,0,0,1,260.334,453.841Z",
    transform: "translate(-207.493 -434)",
    fill: "#244277",
    stroke: "#224074",
    strokeWidth: 0.25
  }))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y2: 16.401,
    transform: "translate(176.13 168.604)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6819",
    "data-name": "Path 6819",
    d: "M-17733.035-8029.947h-39.363v98.408",
    transform: "translate(17817.342 8115.232)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6820",
    "data-name": "Path 6820",
    d: "M-17772.4-8029.947h41.984v99.551",
    transform: "translate(18038.691 8113.591)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_356",
    "data-name": "Subtraction 356",
    d: "M89.328,168.105c-7.789,0-17.559-.73-19.477-2.789-2.555-2.758-3.125-8.324-3.586-12.8l-.008-.062v-.035c-.352-3.437-.652-6.406-1.715-7.352-.469-.41-8.637-3.574-9.645-3.574a.191.191,0,0,0-.051,0c-1.133.238-3.895,2.492-6.336,4.48a46.44,46.44,0,0,1-5.035,3.8,14.473,14.473,0,0,1-6.926,2.2c-2.383,0-4.715-.961-7.574-3.121-2.312-1.75-13.773-10.875-12.16-18.773.6-2.98,3.613-6.746,6.273-10.07l.031-.035c2.059-2.566,3.832-4.785,3.965-6.016.121-1.156-2.762-8.648-3.426-9.348-1.172-1.242-4.48-1.641-8.3-2.105C11.152,102,6.414,101.43,3.8,99.551.73,97.316-.391,88.512.113,81.359c.477-6.727,2.207-11.516,4.625-12.8,2.48-1.3,6.945-1.785,10.887-2.215l.039,0h.02c3.391-.367,6.309-.684,7.309-1.43.789-.605,4.129-9.059,3.961-10.051-.312-2.031-2.109-4.047-4.184-6.379-3.344-3.758-7.133-8.016-6.117-13.863.684-3.934,11.59-15.293,15.523-16.867a11.271,11.271,0,0,1,4.246-.855c4.156,0,7.754,2.477,11.012,5.156.457.379.926.77,1.367,1.148l.012.012c2.543,2.141,4.742,4,6.727,4A3.079,3.079,0,0,0,56,27.172c1.105-.164,8.867-3.512,9.277-4.348.691-1.41.945-4.48,1.211-7.727a43,43,0,0,1,.984-7.352c.973-3.215,3.914-6.8,7.656-7.414A65.99,65.99,0,0,1,83.184,0c4.7,0,10.207.2,11.949.645,2.629.672,4.922,3.254,5.832,5.465.82,2,1.234,5.516,1.641,8.91l0,.047c.426,3.535.82,6.871,1.637,8.059s7.379,3.738,10.223,3.738a2.3,2.3,0,0,0,.82-.121,26.292,26.292,0,0,0,6.734-4.609l.031-.02c3.148-2.66,6.4-5.406,10.527-5.406a11.7,11.7,0,0,1,5.395,1.445c1.613.828,11.07,9.988,12.34,11.777a11.1,11.1,0,0,1,1.16,11.684,31.053,31.053,0,0,1-4.07,5.543l-.023.031c-2.758,3.3-5.6,6.719-5.266,8.82.246,1.52,3.523,9,4.938,9.422a35.142,35.142,0,0,0,6.957,1c4.32.352,8.766.711,11.68,3.008,3.613,2.848,3.5,7.207,3.441,9.3l-.008.016a2.657,2.657,0,0,0,.066,1.086v8.992c1.109,11.527-6.422,12.391-14.383,13.309a50.1,50.1,0,0,0-6.977,1.129c-1.121.3-2.609,2.09-3.98,4.785-1.2,2.371-2,4.855-1.891,5.906.188,1.77,1.949,3.707,3.984,5.949,3.332,3.664,7.484,8.223,6.453,14.16-.672,3.809-9.09,12.348-12.328,14.785-2.8,2.129-5.117,3.078-7.531,3.078a12.678,12.678,0,0,1-5.449-1.414,38.316,38.316,0,0,1-5.68-4.145l-.035-.027c-2.816-2.277-5.734-4.637-7.16-4.863a.151.151,0,0,0-.035,0,68.758,68.758,0,0,0-9.211,3.309c-1.57,1.148-1.852,4.266-2.172,7.871-.527,5.668-1.168,12.7-7.145,15.129A37.43,37.43,0,0,1,89.328,168.105ZM83.5,32.8a57.6,57.6,0,0,0-6.574.375C58.148,35.3,42.629,47.418,35.418,65.59,28.125,83.969,31.3,104.5,43.7,119.156A51.736,51.736,0,0,0,83.91,137.766c23.711,0,43.945-14.883,50.344-37.027,4.781-16.578,1.793-33.711-8.2-47A52.693,52.693,0,0,0,83.5,32.8Z",
    transform: "translate(92.137)",
    fill: "#0071af"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmc);
export default __webpack_public_path__ + "static/media/AMC.2a983e9f2bec99f72e409b8a799ce81d.svg";
export { ForwardRef as ReactComponent };